
/**
 * Custom component for WV Steak House default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-08-29 (1.0.0) (jhoward)
 *    - Copy from <Bimini_defaultSection> component to <WvSteakHouseDefaultSection> component.
 *
 *  2023-11-15 (1.0.1) (jhoward)
 *    - Fix meat temperature line break location in <WvSteakHouseDefaultSection>.
 *
 *  2025-02-10 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <WvSteakHouseDefaultSection> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <WvSteakHouseDefaultSection>.
 *    - Add textual and visual menu CSS tweaks to <WvSteakHouseDefaultSection>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MENU_ITEM_TAG_LOCATIONS, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection, DefaultVisualSection,
  },
  name: "WvSteakHouseDefaultSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
    menuItemTagLocation: {
      type: String as PropType<MENU_ITEM_TAG_LOCATIONS>,
      default: ''
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
  computed: {
    containerClasses(): { [key: string]: boolean } {
      return {
        'menu--section-meat_temperature': this.isMeatTemperatureSection
      };
    },
    isMeatTemperatureSection(): boolean {
      return /(^|\s)meat temperatures?(\s|$)/i.test(this.section.ms_title);
    },
  },
})
